import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import "react-circular-progressbar/dist/styles.css";
import styled from "styled-components";
import useDisplay from "../../hooks/useDisplay";
import { route } from "../../router/route";
import { paymentSubTabList, tabList } from "./../../constant/myPageTab";
import PCContainer from "../../components/atoms/layout/pcContainer";
import LSRgDisplay02 from "./../../components/molecules/text/linSeedKr/Rg/lsRgDisplay02";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import Pagination from "./../../components/molecules/pagination";
import LSRgBody02 from "../../components/molecules/text/linSeedKr/Rg/lsRgBody02";
import LSRgCaption01 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption01";
import MOContainer from "../../components/atoms/layout/moContainer";
import SelectBox from "../../components/organisms/SelectBox";
import { errorHandler } from "../../util/errorHandler";
import Empty from "../../components/molecules/empty";
import PaymentApi from "../../api/payment.api";
import { formatNumberWithCommas } from "../../util/formatNumber";
import StyledCategoryItem from "../../components/molecules/button/styledCategoryItem";
import StyledSubCategoryItem from "../../components/molecules/button/styledSubCategoryItem";
import { toast } from "react-toastify";
import Loading from "../../components/templates/loading";

const MyPagePaymentRefund = () => {
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars

  const [dataList, setDataList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const page = useMemo(() => {
    const requestedPage = Number(searchParams.get("page"));
    return Number.isInteger(requestedPage) && requestedPage > 0
      ? requestedPage
      : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  useEffect(() => {
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("로그인이 필요한 서비스입니다.");
      navigate(
        `${route.login}?returnUrl=${encodeURIComponent(
          route.my_page_payment_refund,
        )}`,
        { replace: true },
      );
      return;
    }

    dataListFunc();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  const dataListFunc = async () => {
    setIsLoading(true);
    try {
      const data = {
        page: page,
        size: pagination.size,
        paymentStatus: "REFUND_REQUEST",
      };

      const response = (await PaymentApi.getList(data)).data.data;

      setDataList(response.content ?? []);
      setPagination((prev) => ({
        ...prev,
        totalCount: response.totalCount,
        totalPages: Math.ceil(response.totalCount / pagination.size),
      }));
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsLoading(false);
    }
  };

  const [subMenuBoxOpen, setSubMenuBoxOpen] = useState(false);
  const [selectedSubMenu, setSelectedSubMenu] = useState(tabList[4].title);

  const [selectedSubMenuTabOpen, setSelectedSubMenuTabOpen] = useState(false);
  const [selectedSubMenuTab, setSelectedSubMenuTab] = useState(
    paymentSubTabList[2].title,
  );

  if (isLoading) return <Loading />;

  return (
    <HomeSection $isSmall={isSmall}>
      {isDesktop && (
        <PCContainer
          style={{
            flexDirection: "column",
            width: "100%",
            padding: isSmall ? "0px 20px" : "0px",
          }}
        >
          <LSRgDisplay02
            style={{
              color: "#000",
              marginBottom: 32,
            }}
          >
            👨‍💻 마이페이지
          </LSRgDisplay02>
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "fit-content",
              gap: 30,
            }}
          >
            {/* 탭 영역 */}
            <TabContainer>
              {tabList.map((tab, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 16,
                  }}
                >
                  <StyledCategoryItem
                    onClick={() => navigate(tab.path)}
                    isActive={index === 4 ? true : false}
                    title={tab.title}
                  />

                  {index === 4 && (
                    <SubTabWrapper>
                      {paymentSubTabList.map((subTab, index) => (
                        <StyledSubCategoryItem
                          key={index}
                          onClick={() => {
                            navigate(subTab.path);
                          }}
                          title={subTab.title}
                          isActive={index === 2 ? true : false}
                        />
                      ))}
                    </SubTabWrapper>
                  )}
                </div>
              ))}
            </TabContainer>
            {/* 본문 영역 */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 30,
              }}
            >
              <ContentContainer>
                <ContentHeaderWrapper>
                  <LSRgDisplay02 style={{ color: "#000" }}>
                    환불 신청 내역
                  </LSRgDisplay02>
                </ContentHeaderWrapper>

                <Table>
                  <thead>
                    <Tr
                      style={{
                        height: 41,
                        backgroundColor: "#EDEDFF",
                      }}
                    >
                      <th
                        style={{
                          width: 146,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <LSRgBody02 style={{ color: "#101113" }}>
                          주문번호
                        </LSRgBody02>
                      </th>
                      <th
                        style={{
                          width: 411,
                          display: "flex",
                          alignItems: "center",
                          paddingLeft: 10,
                        }}
                      >
                        <LSRgBody02 style={{ color: "#101113" }}>
                          강의명
                        </LSRgBody02>
                      </th>
                      <th
                        style={{
                          width: 146,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <LSRgBody02 style={{ color: "#101113" }}>
                          결제수단
                        </LSRgBody02>
                      </th>
                      <th
                        style={{
                          width: 146,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <LSRgBody02 style={{ color: "#101113" }}>
                          결제금액
                        </LSRgBody02>
                      </th>
                      <th
                        style={{
                          width: 146,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <LSRgBody02 style={{ color: "#101113" }}>
                          환불상태
                        </LSRgBody02>
                      </th>
                    </Tr>
                  </thead>
                  <tbody>
                    {dataList.length > 0 ? (
                      dataList.map((item) => (
                        <Tr key={item.id}>
                          <td
                            style={{
                              width: 146,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <LSRgBody02
                              style={{
                                color: "#101113",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {item.pgPaymentId}
                            </LSRgBody02>
                          </td>
                          <td
                            style={{
                              width: 411,
                              display: "flex",
                              alignItems: "center",
                              paddingLeft: 10,
                            }}
                          >
                            <LSRgBody02
                              style={{
                                width: 298,
                                color: "#101113",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {item.lectureTitle}
                            </LSRgBody02>
                          </td>
                          <td
                            style={{
                              width: 146,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <LSRgBody02 style={{ color: "#101113" }}>
                              {item.payMethod}
                            </LSRgBody02>
                          </td>
                          <td
                            style={{
                              width: 146,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <LSRgBody02 style={{ color: "#101113" }}>
                              {formatNumberWithCommas(item.realPay)}원
                            </LSRgBody02>
                          </td>
                          <td
                            style={{
                              width: 146,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <LSRgBody02 style={{ color: "#101113" }}>
                              {item.paymentStatus === "REFUND_COMPLETE"
                                ? "환불완료"
                                : item.paymentStatus === "REFUND_REQUEST"
                                  ? "환불신청"
                                  : "결제완료"}
                            </LSRgBody02>
                          </td>
                        </Tr>
                      ))
                    ) : (
                      <Empty title="환불 신청 내역이 없습니다." />
                    )}
                  </tbody>
                </Table>

                {dataList.length > 0 && (
                  <Pagination
                    route={route.my_page_payment_refund}
                    queryString={``}
                    currentPage={Number(page) || 1}
                    totalPages={pagination.totalPages}
                    rangeSize={pagination.rangeSize}
                  />
                )}
              </ContentContainer>
            </div>
          </div>
        </PCContainer>
      )}

      {/* ******************************** */}
      {/* ********** 모바일 버전 ********** */}
      {/* ******************************** */}
      {isSmall && (
        <MOContainer>
          <ContentContainer $isSmall={isSmall}>
            <ContentHeaderWrapper $isSmall={isSmall}>
              <LSRgH1HeadLine>👨‍💻 마이페이지</LSRgH1HeadLine>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <SelectBox
                  style={{ width: 158 }}
                  subMenuStyle={{ width: 158 }}
                  isSmall={true}
                  isOpen={subMenuBoxOpen}
                  isLink={true}
                  selectedValue={selectedSubMenu}
                  wrapperHandler={() => {
                    setSubMenuBoxOpen(!subMenuBoxOpen);
                  }}
                  itemList={tabList}
                  selectedValueSetterFunc={setSelectedSubMenu}
                />

                <SelectBox
                  style={{ width: 158 }}
                  subMenuStyle={{ width: 158 }}
                  isSmall={true}
                  isOpen={selectedSubMenuTabOpen}
                  isLink={true}
                  selectedValue={selectedSubMenuTab}
                  wrapperHandler={() => {
                    setSelectedSubMenuTabOpen(!selectedSubMenuTabOpen);
                  }}
                  itemList={paymentSubTabList}
                  selectedValueSetterFunc={setSelectedSubMenuTab}
                />
              </div>
            </ContentHeaderWrapper>

            <LSRgH1HeadLine style={{ marginBottom: 20 }}>
              환불 신청 내역
            </LSRgH1HeadLine>

            <Table $isSmall={isSmall}>
              <thead>
                <Tr
                  $isSmall={isSmall}
                  style={{
                    height: 32,
                    backgroundColor: "#EDEDFF",
                  }}
                >
                  <th
                    style={{
                      width: 54,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <LSRgCaption01 style={{ color: "#101113" }}>
                      주문번호
                    </LSRgCaption01>
                  </th>
                  <th
                    style={{
                      width: 77,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <LSRgCaption01 style={{ color: "#101113" }}>
                      강의명
                    </LSRgCaption01>
                  </th>
                  <th
                    style={{
                      width: 67,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <LSRgCaption01 style={{ color: "#101113" }}>
                      결제수단
                    </LSRgCaption01>
                  </th>
                  <th
                    style={{
                      width: 67,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <LSRgCaption01 style={{ color: "#101113" }}>
                      결제금액
                    </LSRgCaption01>
                  </th>
                  <th
                    style={{
                      width: 67,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <LSRgCaption01 style={{ color: "#101113" }}>
                      결제상태
                    </LSRgCaption01>
                  </th>
                </Tr>
              </thead>
              <tbody>
                {dataList.length > 0 ? (
                  dataList.map((item) => (
                    <Tr $isSmall={isSmall} key={item.id}>
                      <td
                        style={{
                          width: 54,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <LSRgCaption01
                          style={{
                            color: "#101113",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item.pgPaymentId}
                        </LSRgCaption01>
                      </td>
                      <td
                        style={{
                          width: 77,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <LSRgCaption01
                          style={{
                            width: 70,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            color: "#101113",
                          }}
                        >
                          {item.lectureTitle}
                        </LSRgCaption01>
                      </td>
                      <td
                        style={{
                          width: 67,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <LSRgCaption01 style={{ color: "#101113" }}>
                          {item.payMethod}
                        </LSRgCaption01>
                      </td>
                      <td
                        style={{
                          width: 67,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <LSRgCaption01 style={{ color: "#101113" }}>
                          {formatNumberWithCommas(item.realPay)}원
                        </LSRgCaption01>
                      </td>
                      <td
                        style={{
                          width: 67,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <LSRgCaption01 style={{ color: "#101113" }}>
                          {item.paymentStatus === "REFUND_COMPLETE"
                            ? "환불완료"
                            : item.paymentStatus === "REFUND_REQUEST"
                              ? "환불신청"
                              : "결제완료"}
                        </LSRgCaption01>
                      </td>
                    </Tr>
                  ))
                ) : (
                  <Empty title={"환불 신청 내역이 없습니다."} />
                )}
              </tbody>
            </Table>

            {dataList.length > 0 && (
              <Pagination
                route={route.my_page_payment_refund}
                queryString={``}
                currentPage={Number(page) || 1}
                totalPages={pagination.totalPages}
                rangeSize={pagination.rangeSize}
              />
            )}
          </ContentContainer>
        </MOContainer>
      )}
    </HomeSection>
  );
};

export default MyPagePaymentRefund;

const HomeSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: ${(props) =>
    props.$isSmall ? "40px 0px 80px 0px" : "80px 0px 150px 0px"};
`;

const TabContainer = styled.div.attrs((props) => {})`
  width: 175px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SubTabWrapper = styled.div.attrs((props) => {})`
  width: 175px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: -6px;
`;

const ContentContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: fit-content;
  display: flex;
  flex-direction: column;
`;

const ContentHeaderWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: ${(props) => (props.$isSmall ? "stretch" : "center")};
  justify-content: space-between;
  flex-direction: ${(props) => (props.$isSmall ? "column" : "row")};
  gap: ${(props) => (props.$isSmall ? "16px" : "0px")};
  margin-bottom: ${(props) => (props.$isSmall ? "40px" : "30px")};
`;

const Table = styled.table.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  border-spacing: 0px;
  border-collapse: collapse;
`;

const Tr = styled.tr.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "995px")};
  height: ${(props) => (props.$isSmall ? "44px" : "52px")};
  border-bottom: 1px solid #dbdde0;
  padding: 16px 0px;
  display: flex;
  align-items: center;
`;
